import request from '@/utils/request'
import { addQueryToUrl } from '@/utils/utils'

const baseUrl = process.env.VUE_APP_PURCHASE_API

import store from '@/store'
import { workbenchServiceDict } from '@/dictionary/system'
import useMaterialNegotiation from '@/components/common/PurchaseListComponent/useMaterialNegotiation'

const tempArray = workbenchServiceDict.array
function getPlatformAlias() {
  return tempArray.find(
    item => item.value === store.state.router.currentWorkbench
  ).platformAlias
}

/** **************公共接口****************** */
// 查询最近的变更数据
export function getNewestChangeInfoApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-changes/last/detail`,
    method: 'get'
  })
}

// 获取最新一条答疑澄清
export function getLastClarificationApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/file-supplements/last/detail`,
    method: 'get'
  })
}

// 查询最新流标公告
export function getLatestAuctionApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-closes/last/detail`,
    method: 'get'
  })
}

// 追加供应商
export function addNegotiationSupplier(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/invite-suppliers/supplement`,
    method: 'post',
    data
  })
}

// 同意供应商的保证金退款
export function agreeNegotiationCandidateRefundApi(orderId, tradeId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-deposits/agree-refund?tradeId=${tradeId}`,
    method: 'post'
  })
}

/** ****************************************************************** */
/** **************项目管理****************** */
// 获取谈判采购包列表
export function getNegotiationPackageListApi(params) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-projects/page`,
    method: 'get',
    params
  })
}

// 导入采购品目列表
export function importNegotiationPackageApi(data) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-projects/purchase-items/import`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 新增项目
export function addNegotiationPackageApi(data, projectId, loading = true) {
  return request(
    {
      url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-projects`,
      method: 'post',
      data: useMaterialNegotiation().batchOrderPostData(data)
    },
    loading
  )
}

// 修改项目
export function editNegotiationPackageApi(data, projectId, loading = true) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}`,
      method: 'put',
      data: useMaterialNegotiation().batchOrderPostData(data)
    },
    loading
  )
}

// 发布项目
export function publishNegotiationPackageApi(data, projectId, loading = true) {
  return request(
    {
      url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-projects/release`,
      method: 'post',
      data: useMaterialNegotiation().batchOrderPostData(data)
    },
    loading
  )
}

// 发布保存的项目
export function publishSavedNegotiationPackageApi(
  data,
  projectId,
  loading = true
) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}/release`,
      method: 'put',
      data: useMaterialNegotiation().batchOrderPostData(data)
    },
    loading
  )
}

// 获取项目详情
export function getNegotiationPackageDetailApi(projectId, loading = true) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}/detail`,
      method: 'get'
    },
    loading
  ).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().batchOrderResData(res.data)
    }
    return res
  })
}

// 删除项目
export function deleteNegotiationPackageApi(projectId) {
  return request({
    url:
      baseUrl + `/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}`,
    method: 'delete'
  })
}

// 查看项目谈判文件
export function previewProjectFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-projects/preview-negotiate-file',
    method: 'get',
    params
  })
}

// 下载项目谈判文件
export function downloadProjectFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-projects/download-negotiate-file',
    method: 'get',
    params
  })
}

// 批量查询谈判采购单信息
export function getProjectsBatchOrdersApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-projects/batch/order-detail',
    method: 'get',
    params
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().batchOrderResData(res.data)
    }
    return res
  })
}

// 导出全部遴选报名表
export function downloadProjectSelectionApi(projectId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}/selection-export`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/** ****************************分项采购************************************** */
/** **************采购端****************** */
// 获取分项谈判列表
export function getNegotiationV2ListApi(params) {
  return request({
    url: baseUrl + '/workbench/purchaser/page/hosp-negotiate-orders',
    method: 'get',
    params
  })
}

// 获取分项采购单详情
export function getNegotiationV2DetailApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/v2/detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeOrderResData(res.data)
    }
    return res
  })
}

// 新增谈判单
export function addNegotiationV2OrderApi(data) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-orders`,
    method: 'post',
    data: useMaterialNegotiation().changeOrderPostData(data)
  })
}

// 修改谈判单
export function editNegotiationV2OrderApi(data, orderId) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}`,
    method: 'put',
    data: useMaterialNegotiation().changeOrderPostData(data)
  })
}

// 发布谈判单
export function publishNegotiationV2OrderApi(data) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-orders/release`,
    method: 'post',
    data: useMaterialNegotiation().changeOrderPostData(data)
  })
}

// 发布保存后的谈判单
export function publishSavedNegotiationV2OrderApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/release`,
    method: 'put',
    data: useMaterialNegotiation().changeOrderPostData(data)
  })
}

// 删除谈判单
export function deleteNegotiationV2OrderApi(orderId) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}`,
    method: 'delete'
  })
}

// 发布变更
export function changeNegotiationV2OrderApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-change/release`,
    method: 'post',
    data
  })
}

// 发布澄清
export function clarifyNegotiationV2OrderApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/file-supplement/release`,
    method: 'post',
    data
  })
}
// 发布流标
export function abandonNegotiationV2OrderApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-close/release`,
    method: 'post',
    data
  })
}

// 保存流标
export function saveAbandonNegotiationV2OrderApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-close`,
    method: 'post',
    data
  })
}

// 获取供应商列表数量
export function getNegotiationV2ApplyCountApi(orderId, params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/count`,
    method: 'get',
    params
  })
}

// 查询报名供应商列表(分页)
export function getNegotiationV2ApplyPageApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/page`,
    method: 'get',
    params
  })
}

// 查询报名供应商列表(不分页)
export function getNegotiationV2ApplyListApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies`,
    method: 'get',
    params
  })
}

// 下载审批附件
export function downloadNegotiationV2FileApi(orderId, applyId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/${applyId}/export`,
      { identity: getPlatformAlias() }
    )
  )
}

// 查询响应详情
export function getNegotiationV2ApplyDetailApi(orderId, applyId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/${applyId}/detail`,
    method: 'get'
  })
}

// 分页查询邀请供应商列表
export function getNegotiationV2InviteSupplierApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-invites/page`,
    method: 'get',
    params
  })
}

// 导出供应商列表
export function exportSupplierListApi(orderId, params = {}) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/suppliers/export`,
      { ...params, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 导出报名资料
export function downloadNegotiationV2SignUpApi(orderId, params = {}) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/export`,
      { ...params, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 分页查询供应商报价列表
export function getNegotiationV2QuoteSupplierApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/page`,
    method: 'get',
    params
  })
}

// 查询供应商报价详情
export function getNegotiationV2QuoteDetailApi(orderId, offerId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/${offerId}/detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeSupplierOrderResData(res.data)
    }
    return res
  })
}

// 开启密封报价
export function openCompareApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/hid-compare-open`,
    method: 'post'
  })
}

// 查询所有供应商的比价详情
export function getCompareDetailApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/compare-detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeCompareAllResData(res.data)
    }
    return res
  })
}

// 查询所有供应商的比价详情 （v2版本，主供应商与品目维度，目前用于比价信息导出）
export function getCompareDetailV2Api(orderId) {
  return request({
    url: `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/v2/compare-detail`,
    method: 'get'
  })
}

// 查询所有供应商的授标信息(未授标)
export function getNoAwardDetailApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/award-detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeCompareAllResData(res.data)
    }
    return res
  })
}

// 查询所有供应商的授标信息(已授标)
export function getAwardDetailApi(orderId, awardId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-awards/${awardId}/award-detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeCompareAllResData(res.data)
    }
    return res
  })
}

// 供应商审核通过
export function passSupplierAuditApi(orderId, applyId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/${applyId}/through`,
    method: 'put'
  })
}

// 供应商审核不通过
export function rejectSupplierAuditApi(orderId, applyId, data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/${applyId}/reject`,
    method: 'put',
    data
  })
}

// 保存候选供应商信息
export function saveNegotiationV2CandidateApi(data, orderId, isModify = false) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-candidates?isModify=${isModify}`,
    method: 'post',
    data
  })
}

// 发布候选供应商信息
export function publishNegotiationV2CandidateApi(
  data,
  orderId,
  isModify = false
) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-candidates/release?isModify=${isModify}`,
    method: 'post',
    data
  })
}

// 查询候选供应商信息
export function getNegotiationV2CandidateApi(orderId, candidateId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-candidates/${candidateId}/detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeCandidateResData(res.data)
    }
    return res
  })
}

// 查询候选历史记录
export function getNegotiationV2CandidateHistoryApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-candidates`,
    method: 'get'
  })
}

// 查询最后一次候选供应商
export function getNegotiationV2CandidateLastApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-candidates/last`,
    method: 'get'
  })
}

// 保存成交供应商信息
export function saveNegotiationV2WinnerApi(data, orderId, isModify = false) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-winners?isModify=${isModify}`,
    method: 'post',
    data
  })
}

// 发布成交供应商信息
export function publishNegotiationV2WinnerApi(data, orderId, isModify = false) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-winners/release?isModify=${isModify}`,
    method: 'post',
    data
  })
}

// 获取成交供应商信息
export function getNegotiationV2WinnerApi(orderId, winnerId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-winners/${winnerId}/detail`,
    method: 'get'
  }).then(res => {
    if (res.data) {
      res.data = useMaterialNegotiation().changeCandidateResData(res.data)
    }
    return res
  })
}

// 查询最后一次的成交信息
export function getLastWinnerApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-winners/last`,
    method: 'get'
  })
}

// 查询成交历史记录
export function getNegotiationV2WinnerHistoryApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-winners`,
    method: 'get'
  })
}

// 导入分项谈判-品目列表
export function importNegotiationItemApi(data) {
  return request(
    {
      url: baseUrl + '/workbench/template/hosp-negotiate-item/import',
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    },
    true,
    true
  )
}

// 导出比价表
export function exportNegotiationV2CompareInfoApi(orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/purchaser/hosp-negotiate-orders/${orderId}/supplier-offers/compare-detail/export`,
      { identity: getPlatformAlias() }
    )
  )
}

// 查看谈判文件(采购端)
export function previewPurchaseFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-orders/preview-negotiate-file',
    method: 'get',
    params
  })
}

// 下载谈判文件(采购端)
export function downloadPurchaseFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-orders/download-negotiate-file',
    method: 'get',
    params
  })
}

// 查看澄清文件(采购端)
export function previewClarificationFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-orders/preview-supplement-file',
    method: 'get',
    params
  })
}

// 下载澄清文件(采购端)
export function downloadClarificationFileApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-orders/download-supplement-file',
    method: 'get',
    params
  })
}

// 批量查询分项谈判采购单基础信息
export function getBatchOrdersApi(params) {
  return request({
    url:
      baseUrl + '/workbench/v2/purchaser/hosp-negotiate-orders/batch/base-info',
    method: 'get',
    params
  })
}

// 批量查询邀请函列表
export function getBatchInviteSupplierApi(params) {
  return request({
    url:
      baseUrl +
      '/workbench/v2/purchaser/hosp-negotiate-orders/supplier-invites/batch-list',
    method: 'get',
    params
  })
}

// 批量变更
export function publishBatchChangesApi(data, orderIds, loading = true) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/notice-change/release-batch?orderIds=${orderIds}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量答疑
export function publishBatchClarificationApi(data, orderIds) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/file-supplement/release-batch?orderIds=${orderIds}`,
    method: 'post',
    data
  })
}

// 批量流标
export function publishBatchAuctionApi(data, orderIds, loading = true) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/notice-close/release-batch?orderIds=${orderIds}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量候选
export function publishBatchCandidateApi(
  data,
  orderIds,
  isModify = false,
  loading = true
) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/supplier-candidates/release-batch?orderIds=${orderIds}&isModify=${isModify}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量保存候选
export function saveBatchCandidateApi(
  data,
  orderIds,
  isModify = false,
  loading = false
) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/supplier-candidates/save-batch?orderIds=${orderIds}&isModify=${isModify}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量成交
export function publishBatchWinnerApi(
  data,
  orderIds,
  isModify = false,
  loading = true
) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/supplier-winners/release-batch?orderIds=${orderIds}&isModify=${isModify}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量保存成交
export function saveBatchWinnerApi(
  data,
  orderIds,
  isModify = false,
  loading = false
) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/supplier-winners/save-batch?orderIds=${orderIds}&isModify=${isModify}`,
      method: 'post',
      data
    },
    loading
  )
}

// 批量追加供应商
export function addBatchNegotiationSupplier(data, orderIds, loading = false) {
  return request(
    {
      url:
        baseUrl +
        `/workbench/v2/purchaser/hosp-negotiate-orders/invite-suppliers/supplement-batch?orderIds=${orderIds}`,
      method: 'post',
      data
    },
    loading
  )
}

// 获取已发布的公告列表
export function getNegotiationV2PublishNoticeApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/release-notices`,
    method: 'get'
  })
}

// 查看最新变更公告详情
export function getNegotiationV2NewestChangeInfoApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-changes/last/detail`,
    method: 'get'
  })
}

// 查询最新流标公告
export function getNegotiationV2NewestAuctionApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/notice-closes/last/detail`,
    method: 'get'
  })
}

// 下载品目模板（无项目id）
export function downloadNegotiationV2MaterialTemplateByOrderId(orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/item-template`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 下载品目模板（有项目id）
export function downloadNegotiationV2MaterialTemplateByProjectIdApi(projectId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-projects/${projectId}/item-template`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 提交报名审批流
export function submitNegotiationV2FlowApi(orderId, applyId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-applies/${applyId}/signup-flows/start`,
    method: 'put'
  })
}

// 下载遴选表ZIP(审核工作台)
export function exportNegotiationV2AllSelectionZipApi(orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/downLoad-Zip`,
      { identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

/** ******************************************************* */

/** ***********************机场谈判采购******************************** */

// 保存谈判
export function saveNegotiationApi(data) {
  return request({
    url: baseUrl + '/workbench/v2/purchaser/jc/negotiate-orders',
    method: 'post',
    data
  })
}

// 更改谈判
export function updateNegotiationApi(data, orderId) {
  return request({
    url: baseUrl + `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}`,
    method: 'put',
    data
  })
}

// 发布谈判
export function publishNegotiationApi(data) {
  return request({
    url: baseUrl + '/workbench/v2/purchaser/jc/negotiate-orders/release',
    method: 'post',
    data
  })
}

// 发布保存的谈判
export function publishSavedNegotiationApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/release`,
    method: 'put',
    data
  })
}

// 发起多次谈判
export function publishNegotiateRoundApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/rounds/submit`,
    method: 'post',
    data
  })
}

// 查询响应供应商列表
export function getNegotiationResponseListApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/page`,
    method: 'get',
    params
  })
}

// 查询响应供应商统计
export function getNegotiationResponseSumApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/total`,
    method: 'get',
    params
  })
}

// 进入评审
export function enterNegotiationReviewApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/rounds/end`,
    method: 'post'
  })
}

// 查询响应供应商详情
export function getNegotiationResponseDetailApi(orderId, responseId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/${responseId}/detail`,
    method: 'get'
  })
}

// 响应供应商审查通过
export function passNegotiationResponseApi(orderId, responseId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/${responseId}/through`,
    method: 'put'
  })
}

// 响应供应商审查通过
export function rejectNegotiationResponseApi(orderId, responseId, data) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/${responseId}/reject`,
    method: 'put',
    data
  })
}

// 下载全部响应文件
export function downloadNegotiationResponseFileApi(params, orderId) {
  window.open(
    addQueryToUrl(
      `${baseUrl}/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-file-responses/export`,
      { ...params, identity: getPlatformAlias() }
    ),
    '_blank'
  )
}

// 开启谈判
export function openNegotiateApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/supplier-offers/negotiate-open`,
    method: 'post'
  })
}

// 保存评审结果
export function saveNegotiationReviewResultApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/reviews`,
    method: 'post',
    data
  })
}

// 保存评审结果
export function publishNegotiationReviewResultApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/reviews/release`,
    method: 'post',
    data
  })
}

// 查询最后一次的评审结果
export function getNegotiationReviewResultApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/reviews/last/detail`,
    method: 'post'
  })
}

// 获取评审推荐候选供应商
export function getNegotiationReviewSupplierApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${params.orderId}/file-response-result/page`,
    method: 'get',
    params
  })
}

// 查询供应商文件响应列表
export function getNegotiationAllResponseApi(params, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/jc/negotiate-orders/${orderId}/suppliers/file-responses/detail`,
    method: 'get',
    params
  })
}

// 查看响应文件(采购端)
export function previewNegotiationResponseApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/preview-supplier-response-file`,
    method: 'get',
    params
  })
}

// 下载响应文件(采购端)
export function downloadNegotiationResponseApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/download-supplier-response-file`,
    method: 'get',
    params
  })
}

// 预览多次谈判文件
export function previewNegotiationRoundFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/preview-round-file`,
    method: 'get',
    params
  })
}

// 下载多次谈判文件
export function downloadNegotiationRoundFileApi(params) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/download-round-file`,
    method: 'get',
    params
  })
}

// 预览成交结果通知书
export function previewNegotiationResultFileApi(params) {
  const { orderId, ...other } = params
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/preview-notice-file`,
    method: 'get',
    params: other
  })
}

// 下载成交结果通知书
export function downloadNegotiationResultFileApi(params) {
  const { orderId, ...other } = params
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/download-notice-file`,
    method: 'get',
    params: other
  })
}

// 查询需生成通知书的供应商列表
export function getNeedFileSupplierListApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplier-notices/suppliers`,
    method: 'get'
  })
}

/** *******************审批流*************************** */

// 提交发布审批
export function startFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/release-flows/start`,
    method: 'put'
  })
}

// 提交变更审批
export function startChangeFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/change-flows/start`,
    method: 'put'
  })
}

// 提交澄清审批
export function startSupplementFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/supplement-flows/start`,
    method: 'put'
  })
}

// 提交候选审批
export function startCandidateFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/candidate-flows/start`,
    method: 'put'
  })
}

// 提交成交审批
export function startWinnerFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/winner-flows/start`,
    method: 'put'
  })
}

// 提交流标审批
export function startAuctionFlowsApi(orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/close-flows/start`,
    method: 'put'
  })
}
